import React from 'react';
import '../Components/OurMission.css';


import "@fontsource/plus-jakarta-sans";
const OurMissionSection = () => {

  const ourMissionImg = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/ourmission.png';
const ourStoryImg = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/ourstory.png';

  return (
    <div className="our-containers text-white py-5">
      <div className="overflow-hidden">
        <div className="row align-items-center mb-5 gx-4 gy-4">
          <div className="col-md-6">
            <img 
              src={ourMissionImg} 
              alt="Our Mission" 
              className="img-fluid rounded"
            />
          </div>
          <div className="col-md-6">
            <div className='d-flex justify-content-center'>
              <div className='plr-20'>
            <h1 className="mission-hed mb-3 font-25" style={{fontSize:'40px',fontWeight:'700'}}>
              Our Mission
            </h1>
            <p className="mission-text" style={{ color: '#FFFFFFCC', fontSize:'16px'}}>
              Our mission at DataMetricks is simple: To empower businesses with
              <br className="desktop-br"/>
              cutting-edge digital solutions that drive growth, improve online
              <br className="desktop-br"/>
              visibility, and create meaningful connections with customers.
              <br className="desktop-br"/>
            </p>
            </div>
            </div>
          </div>
        </div>
        
        <div className="row align-items-center gx-4 gy-4 flex-column-reverse flex-md-row" style={{marginLeft:'80px'}}>
          <div className="col-md-6">
            <div className='plr-10'>
            <h1 className="mission-hed mb-3 font-25" style={{fontSize:'40px',fontWeight:'700'}}>
              Our Vision
            </h1>
            <p className="mission-text" style={{ color: '#FFFFFFCC', fontSize:'16px'}}>
              We envision a future where businesses, no matter their size, leverage
              <br className="desktop-br"/>
              the power of smart web development and marketing strategies to 
              <br className="desktop-br"/>
              unlock their full potential in the digital world.
            </p>
            </div>
          </div>
          <div className="col-md-6">
            <img 
              src={ourStoryImg} 
              alt="Our Vision" 
              className="img-fluid rounded"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurMissionSection;